import { render, staticRenderFns } from "./checklistImpr.vue?vue&type=template&id=0bb9668a"
import script from "./checklistImpr.vue?vue&type=script&lang=js"
export * from "./checklistImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb9668a')) {
      api.createRecord('0bb9668a', component.options)
    } else {
      api.reload('0bb9668a', component.options)
    }
    module.hot.accept("./checklistImpr.vue?vue&type=template&id=0bb9668a", function () {
      api.rerender('0bb9668a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/risk/checklistImpr.vue"
export default component.exports